var _mask, _path, _mask2, _rect, _rect2, _mask3, _rect3, _rect4, _mask4, _rect5, _rect6, _mask5, _rect7, _rect8, _mask6, _rect9, _rect0, _mask7, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.118C0 17.7393 0.214002 17.393 0.552786 17.2236L34.5528 0.223606C34.8343 0.0828426 35.1657 0.0828431 35.4472 0.223607L69.4472 17.2236C69.786 17.393 70 17.7393 70 18.118V69C70 69.5523 69.5523 70 69 70H68.751C68.1988 70 67.751 69.5523 67.751 69V22.735C67.751 22.1827 67.3033 21.735 66.751 21.735H3.25281C2.70052 21.735 2.25281 22.1827 2.25281 22.735V69C2.25281 69.5523 1.80509 70 1.25281 70H1C0.447715 70 0 69.5523 0 69V18.118Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.118C0 17.7393 0.214002 17.393 0.552786 17.2236L34.5528 0.223606C34.8343 0.0828426 35.1657 0.0828431 35.4472 0.223607L69.4472 17.2236C69.786 17.393 70 17.7393 70 18.118V69C70 69.5523 69.5523 70 69 70H68.751C68.1988 70 67.751 69.5523 67.751 69V22.735C67.751 22.1827 67.3033 21.735 66.751 21.735H3.25281C2.70052 21.735 2.25281 22.1827 2.25281 22.735V69C2.25281 69.5523 1.80509 70 1.25281 70H1C0.447715 70 0 69.5523 0 69V18.118Z",
    stroke: "#1B1E59",
    strokeWidth: 4.5,
    mask: "url(#path-1-inside-1_2001_10204)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.4277,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.4277,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-2-inside-2_2001_10204)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8027,
    y: 62.8749,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.4277,
    y: 50.75,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4277,
    y: 50.75,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-4-inside-3_2001_10204)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8027,
    y: 54.1244,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-4_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.6777,
    y: 50.75,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6777,
    y: 50.75,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-6-inside-4_2001_10204)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0527,
    y: 54.1249,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-5_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.6777,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6777,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-8-inside-5_2001_10204)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0527,
    y: 62.8749,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-6_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.9277,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9277,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-10-inside-6_2001_10204)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 39.582,
    y: 62.8749,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-7_2001_10204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.125,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 25.125,
    y: 59.5,
    width: 10.5,
    height: 10.5,
    rx: 1,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 3.5,
    mask: "url(#path-12-inside-7_2001_10204)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 62.8749,
    width: 0.75,
    height: 0.75,
    rx: 0.375,
    fill: "#1B1E59",
    stroke: "#1B1E59",
    strokeWidth: 0.75
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4.17773,
    y: 23.7647,
    width: 59.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1B1E59"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4.17773,
    y: 27.6324,
    width: 59.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1B1E59"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.17773,
    y: 31.5,
    width: 59.5,
    height: 1.75,
    rx: 0.875,
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarehouse);
export default __webpack_public_path__ + "static/media/Icon_Warehouse.3e33afb5a1794492fed748edbdd6d9ae.svg";
export { ForwardRef as ReactComponent };